import mixpanel from 'mixpanel-browser';
import { APP_CONFIG } from 'app/consts/config';

// Near entry of your product, init Mixpanel
mixpanel.init(APP_CONFIG.mixpanelKey, {
  debug: true,
  track_pageview: true,
  persistence: 'localStorage',
});
